module.exports = __webpack_public_path__ + "static/media/backrise-15.e50ceec2.png";